import { DEFAULT_BMI } from 'constants/user/personalization';

export const getBMI = (weight: number | null, height: number | null) => {
    if (!weight || !height) return DEFAULT_BMI;

    const calculatedBMI = weight / Math.pow(height / 100, 2);

    return Number(calculatedBMI.toFixed(2));
};
